import { render, staticRenderFns } from "./VoteContainer.vue?vue&type=template&id=3b3c48b6&scoped=true&"
import script from "./VoteContainer.vue?vue&type=script&lang=js&"
export * from "./VoteContainer.vue?vue&type=script&lang=js&"
import style0 from "./VoteContainer.vue?vue&type=style&index=0&id=3b3c48b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3c48b6",
  null
  
)

export default component.exports